





































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
// Models
import BaseModel from '@/models/baseModel';
// Components
import Label from '@/components/common/elements/Label.vue';
import Input from '@/components/common/elements/Input.vue';
import Dialog from '@/components/common/modules/Dialog.vue';

@Component({
  components: {
    Label,
    Input,
    Dialog
  }
})
export default class Zipcode extends Vue {
  // Props
  @Prop({ default: '' })
  private label?: string;
  @Prop({ default: '' })
  private value!: string;
  // 入力要素名
  @Prop({ default: '' })
  private name!: string;
  @Prop({ default: false })
  private isReadonly?: boolean;
  @Prop({ default: false })
  private isDisabled?: boolean;
  // バリデーションルール
  @Prop({ default: '' })
  private rules?: string;
  // Constants
  // Variables
  private isShowLabel = false;
  private model = new BaseModel();
  // Dialog
  private isShowDialog = false;
  private dialogTitle = '';
  private dialogMessage = '';

  // 郵便番号取得時に取得結果がない場合のエラーフラグ
  private postalErrorFlag = false;
  // 郵便番号取得エラーレスポンス時のダイアログ文言用ヘッダー
  private postalErrorHeader = '郵便番号取得：';

  mounted() {
    if (this.label !== '') {
      this.isShowLabel = true;
    }
  }

  private modifyRule(rule: string){
    const result:string[] = [];
    const rules = rule;
    if(rules === undefined || rules.length === 0 ) return '';

    if (this.postalErrorFlag === true) {
      result.push(rules);
      result.push(`error_postal_code:${true}`);
      return result.join('|');      
    } else {
      return rules;
    }
  }

  private async onButtonClicked() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);
      this.postalErrorFlag = false;
      const response = await this.model.getAddressInformation({ zipcode: this.value });
      if (response.status === 400 || response.status === 500) {
        this.isShowDialog = true;
        this.dialogMessage = this.postalErrorHeader + response.message;
      } else {
        if (response.results !== null) {
          this.emit(response.results);
        } else {
          this.postalErrorFlag = true;
          if (this.rules) {
            this.modifyRule(this.rules)
          }
        }
      }
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  @Emit('inputOperation')
  private catchInput(event: any) {
    this.postalErrorFlag = false;
    if (this.rules) {
      this.modifyRule(this.rules);
    }
    return { name: 'postal_code', value: event.value };
  }

  private confirmOpratipon(event: any) {
    this.isShowDialog = event.dialog;
  }

  @Emit('getAddress')
  private emit(value: any) {
    return value;
  }
}
